var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x93\x91 \xEB\xB6\x81\xEB\xA7\x88\xED\x81\xAC \xED\x83\xAD",
    clipPath: "url(#clip0_1875_8612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49902 4.98V34.02C6.49902 35.114 7.38502 36 8.47902 36H24.649L34.549 26.1V4.98C34.549 3.886 33.663 3 32.569 3H8.47902C7.38502 3 6.49902 3.886 6.49902 4.98Z",
    fill: "#E5E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.63 26.1001H34.55L24.65 36.0001V28.0801C24.65 26.9861 25.536 26.1001 26.63 26.1001Z",
    fill: "#C0C7D1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1875_8612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementBookmark);
export default __webpack_public_path__ + "static/media/icon_settlement_bookmark.d09c0815108911871861cf438b99255e.svg";
export { ForwardRef as ReactComponent };